import { render, staticRenderFns } from "./CanvasCrackSingleDesign.vue?vue&type=template&id=533ce5d2&scoped=true&"
import script from "./CanvasCrackSingleDesign.vue?vue&type=script&lang=js&"
export * from "./CanvasCrackSingleDesign.vue?vue&type=script&lang=js&"
import style0 from "./CanvasCrackSingleDesign.vue?vue&type=style&index=0&id=533ce5d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ce5d2",
  null
  
)

export default component.exports